export default "__VITE_ASSET__DdeQ7FHP__"